import { html, render } from 'lit-html';

import { RadioGroup } from '@disy/ui/radio-group';

import type { ClassificationType } from 'cadenza/workbook/model/classification-type.gen';
import i18n from 'cadenza/workbook/workbook-panel/settings/map/advanced-data-layer-settings/advanced-color-classification-settings/advanced-color-classification-settings.properties';

const COMPONENT_NAME = 'd-symbolization-type';

/**
 * @attr readonly
 */
export class ClassificationTypeElement extends HTMLElement {
  static observedAttributes = ['readonly'] as const;

  #value: ClassificationType = 'INTERVAL';
  #content?: RadioGroup<ClassificationType>;

  connectedCallback() {
    this.#render();
  }

  attributeChangedCallback() {
    this.#render();
  }

  #render() {
    if (!this.readOnly) {
      this.#content ??= createRadioGroup(this.#value);
    }
    render(
      html`${this.readOnly ? html`<span>${i18n(`symbolizationType.<${this.#value}>`)}</span>` : this.#content}`,
      this,
    );
  }

  get value() {
    return this.#content?.value ?? this.#value;
  }

  set value(value: ClassificationType) {
    this.#value = value;
    if (this.#content) {
      this.#content.value = value;
    }
    this.#render();
  }

  get readOnly() {
    return this.hasAttribute('readonly');
  }

  set readOnly(value: boolean) {
    this.toggleAttribute('readonly', value);
    this.#render();
  }
}

customElements.define(COMPONENT_NAME, ClassificationTypeElement);

function createRadioGroup(value: ClassificationType) {
  const values = [
    { value: 'INTERVAL' as const, label: i18n('symbolizationType.<INTERVAL>') },
    { value: 'UNIQUE_VALUES' as const, label: i18n('symbolizationType.<UNIQUE_VALUES>') },
  ];
  return new RadioGroup<ClassificationType>(values, { initialValue: value });
}
